import r from "dayjs";
const Y = (Y2) => {
  if (!Y2) return "-";
  const t = Y2.length;
  if (4 === t) return Y2;
  if (7 === t) {
    const t2 = r(Y2, "YYYY.MM").locale("uk").format("MMMM YYYY");
    return (M = t2).charAt(0).toUpperCase() + M.slice(1);
  }
  var M;
  return 10 === t ? r(Y2, "MM/DD/YYYY").locale("uk").format("D MMMM YYYY") : Y2;
};
export {
  Y as formatDateForBarChart
};
//# sourceMappingURL=formatDateForBarChart.js.map
